export default {
  title: 'Téléconsultation',
  subtitle: 'Consultez un médecin expert en quelques minutes, où que vous soyez.',
  errorStart: 'Erreur lors du démarrage de la consultation',
  doctorWaiting: '{{name}} vous attend',
  defaultDoctor: 'Le médecin',
  newCare: {
    title: 'Nouveau Soin',
    description: "Démarrage immédiat d'une consultation vidéo ou audio sécurisée.",
    action: 'Commencer maintenant'
  },
  availability: {
    title: 'Disponibilités',
    doctorAvailable: 'Médecin disponible',
    activeQueue: "File d'attente active",
    estimatedWait: 'Attente estimée: 5-10 min',
    support24h: 'Garde médicale 24h/24'
  },
  techStandard: {
    title: 'Standard Technologique EKOSE-RX',
    videoHd: 'Vidéo HD',
    videoHdDesc: 'Flux optimisé',
    secureChat: 'Chat Sécurisé',
    secureChatDesc: 'Échanges chiffrés',
    hdsArchiving: 'Archivage HDS',
    hdsArchivingDesc: 'Suivi patient'
  },
  form: {
    title: 'Nouvelle',
    titleHighlight: 'Téléconsultation',
    subtitle: 'Décrivez vos symptômes pour être mis en relation avec un médecin',
    typeLabel: 'Type de consultation',
    videoType: 'Vidéo HD',
    audioType: 'Audio Seul',
    symptomsLabel: 'Vos Symptômes',
    symptomsPlaceholder: 'Décrivez vos symptômes, leur durée, leur intensité...',
    doctorAvailableDesc: 'Connexion directe possible',
    queueDesc: 'Mise en relation sous peu',
    queueLabel: "File d'attente",
    cancel: 'Annuler',
    submit: 'Démarrer la consultation',
    starting: 'Démarrage...'
  },
  waitingRoom: {
    patient: {
      loadingTitle: 'Connexion',
      loadingTitleHighlight: 'Elite',
      loadingSubtitle: 'Sécurisation du tunnel HDS...',
      welcomeTitle: 'Bienvenue',
      welcomeSubtitle: 'Espace Médical Privé',
      liveSession: 'Live Session',
      hdsMedicalGrade: 'Grade Médical HDS',
      roomTitle: "Salles d'attente",
      roomTitleHighlight: 'Elite',
      syncActive: 'Sync Active',
      reconnecting: 'Reconnect...',
      cancel: 'Annuler',
      synchronized: 'Synchronisé',
      prepareConsultation: 'Préparez-vous à la consultation',
      priorityRoom: "Salle d'Attente Prioritaire",
      encryptedSession: 'Votre session est chiffrée de bout-en-bout. Le Docteur a reçu votre alerte de présence.',
      keepWindowOpen: "Gardez cette fenêtre ouverte pour l'auto-connexion.",
      position: 'Position',
      estimatedWait: 'Attente Estimée',
      min: 'min',
      eliteConfidentiality: 'Confidentialité Elite',
      encryptedFlows: "Flux cryptés AES-256. Aucune donnée n'est stockée hors tunnel HDS.",
      optimizedSignal: 'Signal Optimisé',
      autoQuality: 'EKOSE ajuste automatiquement la qualité vidéo selon votre réseau.',
      syncError: 'Erreur de Synchronisation',
      chatLive: 'Chat Live',
      online: 'En ligne',
      chatUnavailable: 'Chat Indisponible'
    },
    doctor: {
      realTime: 'Temps Réel',
      systemActive: 'Système Actif',
      offline: 'Hors ligne',
      roomTitle: "Salle d'Attente",
      waiting: 'en attente',
      available: 'Disponible',
      busy: 'Occupé',
      statWaiting: 'En attente',
      statUrgent: 'Urgents',
      statAverage: 'Moyenne',
      statMessages: 'Messages',
      interactiveQueue: "File d'Attente Interactive",
      sortedByUrgency: "Patients triés par degré d'urgence",
      loading: 'Chargement...',
      noPatients: 'Aucun patient en attente',
      noPatientsDesc: "La salle d'attente est vide. Vous serez notifié lorsqu'un patient arrivera.",
      symptomsNotSpecified: 'Symptômes non précisés',
      chat: 'Chat',
      treat: 'Traiter',
      directLink: 'Liaison directe : {{name}}',
      statusAvailable: 'Statut disponible',
      statusAvailableDesc: 'Vous recevez les nouvelles consultations automatiquement',
      patientSupport: 'Support patient',
      patientSupportDesc: 'Répondez aux questions des patients via le chat intégré',
      quickConsultation: 'Consultation rapide',
      quickConsultationDesc: 'Démarrez une téléconsultation en un clic'
    }
  },
  videoCall: {
    initializationEkose: "Initialisation EKOSE",
    securingTunnel: "Sécurisation du tunnel de consultation en cours...",
    streamError: "Erreur de Flux",
    retryConnection: "Réessayer la connexion",
    cameraDisabled: "Caméra désactivée",
    audioOnlySecured: "Flux audio seul • Sécurisé",
    patientApproaching: "Patient en approche...",
    practitionerArriving: "Le Praticien arrive...",
    patientFinalizingConnection: "Le patient finalise sa connexion sécurisée. La vidéo s'affichera automatiquement.",
    doctorJoiningConsultation: "Votre médecin rejoint la consultation. Préparez vos questions.",
    cacheEnabled: "Cache activé",
    you: "Vous",
    ekoseProtectedLine: "EKOSE PROTECTED LINE"
  },
  errors: {
    loadFailed: 'Erreur lors du chargement de la consultation.',
    availabilityFailed: 'Erreur lors de la récupération de la disponibilité des médecins.',
    unauthenticated: 'Utilisateur non authentifié.',
    cannotStart: 'Impossible de démarrer une consultation dans cet état.',
    alreadyInProgress: "Une consultation est déjà en cours. Veuillez la rejoindre ou l'annuler.",
    startFailed: 'Erreur lors du démarrage de la consultation.',
    invalidSession: 'Session de consultation invalide.',
    cancelFailed: "Erreur lors de l'annulation de la consultation.",
    joinQueueFailed: "Impossible de rejoindre la salle d'attente",
    unauthenticatedOrDisconnected: 'Utilisateur non authentifié ou non connecté.',
    endFailed: 'Une erreur est survenue lors de la fin de la consultation.',
    cancelled: 'Votre consultation a été annulée.',
    messageSendFailed: "Impossible d'envoyer le message. Veuillez réessayer."
  },
  waitingRoomService: {
    positionInQueue: "Vous êtes en position {{position}} dans la file d'attente",
    patientJoined: "{{name}} vient de rejoindre la salle d'attente",
    welcomeToast: "🏥 Vous êtes en salle d'attente (position {{position}})",
    positionImproved: "🎉 Votre position s'améliore ! Vous êtes maintenant {{position}}{{suffix}}",
    positionCurrent: "Votre position dans la file : {{position}}{{suffix}}",
    waitTimeReduced: "⚡ Temps d'attente réduit de {{diff}} minutes ! Estimation : {{time}} min",
    waitTimeUpdated: "Temps d'attente mis à jour : {{time}} minutes",
    doctorAssigned: "👨‍⚕️ Médecin assigné : Dr. {{name}}",
    doctorAssignedDefault: "👨‍⚕️ Médecin assigné : Dr. Médecin",
    doctorAssignedSpecialty: " ({{specialty}})",
    statusDoctorAssigned: "✅ Un médecin vous a été assigné",
    statusConsultationStarting: "🚀 Votre consultation va commencer !",
    statusCancelled: "❌ Consultation annulée",
    delayDetected: "⏰ Délai détecté : +{{minutes}} minutes par rapport à l'estimation",
    delayToast: "⏰ Votre consultation prend un peu plus de temps que prévu",
    progress: "📊 Progression : {{percent}}% du temps d'attente estimé",
    noInfo: "Aucune information disponible",
    summaryPosition: "📍 Position: {{position}}{{suffix}}",
    summaryWaitTime: "⏱️ Temps d'attente: {{current}}/{{estimated}} min",
    summaryDoctor: "👨‍⚕️ Médecin: Dr. {{name}}",
    summaryStatus: "📊 Statut: {{status}}",
    statusLabels: {
      waiting: "En attente",
      doctorAssigned: "Médecin assigné",
      consultationStarting: "Consultation en cours de démarrage",
      cancelled: "Annulée",
      unknown: "Inconnu"
    },
    positionSuffix: {
      first: "er",
      other: "ème"
    }
  }
};
